import React from 'react';
import { Box } from '@mui/material';
import ToolsPanelContentTransition from './ToolsPanelContentTransition';
import ToolsPanelLoadingOverlay from './ToolsPanelLoadingOverlay';
import { useChatToolsPanelLoading } from './useChatToolsPanelLoading';

interface ToolsPanelChromeProps {
  panelId: string;
  /** פעיל רק כשהפאנל הזה מוצג בדואר ימני */
  isActive: boolean;
  children: React.ReactNode;
}

/** מעטפת: מעבר תוכן + שכבת טעינה — memo לביצועים */
const ToolsPanelChrome: React.FC<ToolsPanelChromeProps> = ({ panelId, isActive, children }) => {
  const loading = useChatToolsPanelLoading(panelId, isActive);

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        flex: '1 1 auto',
        minHeight: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <ToolsPanelContentTransition panelKey={panelId}>{children}</ToolsPanelContentTransition>
      <ToolsPanelLoadingOverlay open={loading} />
    </Box>
  );
};

export default React.memo(ToolsPanelChrome);
